import React, { Component } from 'react';

const _menuMap = {
  "/introduce01": "01 학습 유형에 따른 토즈만의 5가지 학습공간",
  "/introduce02": "02 토즈만의 전문적인 관리 서비스",
  "/introduce03": "03 등록 안내 및 문의",
  "/introduce04": "04 고객센터"
}

class IntroduceTopMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTopMenu: false
    };
  }

  render() {
    return (
      <div className={this.state.isTopMenu ? "info-menu on" : "info-menu"}>
        <a href={null} className="btxt" onClick={() => this.setState({isTopMenu: !this.state.isTopMenu}) }>{_menuMap[this.props.link]}</a>
        <ul className={this.state.isTopMenu ? "list on" : "list"}>
          { Object.entries(_menuMap).map(([key, value]) => <li key={key}><a href={key}>{value}</a></li>) }
        </ul>
      </div>
    )
  }
}

export default IntroduceTopMenu;